<template>
  <aside class="col-lg-2" id="sidebar">
    <div class="box_detail" v-if="userStatus == 1">
      <ul class="cart_details">
        <li
          class="nav-item"
          data-toggle="tooltip"
          title=""
          data-original-title="My Account"
        >
          <router-link
            class="nav-link nav-link-collapse collapsed"
            to="/my-account"
            aria-expanded="false"
          >
            <i class="fa fa-dashboard"></i>
            <span class="nav-link-text">Dashboard</span>
          </router-link>
        </li>

        <li
          class="nav-item"
          v-show="roleId == 2"
          data-toggle="tooltip"
          title=""
          data-original-title="My Account"
        >
          <router-link class="nav-link nav-link-collapse collapsed" to="/offer-list">
            <i class="fa fa-home"></i>
            <span class="nav-link-text">Offers List</span>
          </router-link>
        </li>
        <li
          class="nav-item"
          v-show="roleId == 2"
          data-toggle="tooltip"
          title=""
          data-original-title="My Account"
        >
          <router-link class="nav-link nav-link-collapse collapsed" to="/journey-list">
            <i class="fa fa-home"></i>
            <span class="nav-link-text">Traveller List</span>
          </router-link>
        </li>
       
        <li
          class="nav-item"
          v-show="roleId == 2"
          data-toggle="tooltip"
          title="Banner List"
          data-original-title="Banner List"
        >
          <router-link class="nav-link nav-link-collapse collapsed" to="/banner-list">
            <i class="fa fa-home"></i>
            <span class="nav-link-text">Banner List</span>
          </router-link>
        </li>
        <li
          class="nav-item"
          v-show="roleId == 2"
          data-toggle="tooltip"
          title="Featured Offer"
          data-original-title="Featured Offer"
        >
          <router-link class="nav-link nav-link-collapse collapsed" to="/featured-list">
            <i class="fa fa-home"></i>
            <span class="nav-link-text">Featured Offer</span>
          </router-link>
        </li>
        <!--li
          class="nav-item"
          v-show="roleId == 2"
          data-toggle="tooltip"
          title=""
          data-original-title="My Account"
        >
          <a class="nav-link nav-link-collapse collapsed" href="/create-offers">
            <i class="fa fa-home"></i>
            <span class="nav-link-text">New Offers</span>
          </a>
        </li-->
        <li
          class="nav-item"
          v-show="roleId == 2"
          data-toggle="tooltip"
          title=""
          data-original-title="My Account"
        >
          <router-link
            class="nav-link nav-link-collapse collapsed"
            to="/vendor-services"
          >
            <i class="fa fa-home"></i>
            <span class="nav-link-text">Offer categories</span>
          </router-link>
        </li>

        <li
          class="nav-item"
          v-show="roleId == 2"
          data-toggle="tooltip"
          title=""
          data-original-title="My Account"
        >
          <router-link
            class="nav-link nav-link-collapse collapsed"
            to="/balance-credits"
            aria-expanded="false"
          >
            <i class="fa fa-money"></i>
            <span class="nav-link-text">Balance Credits</span>
          </router-link>
        </li>

        <li
          class="nav-item"
          v-show="roleId == 2"
          data-toggle="tooltip"
          title=""
          data-original-title="Promotions"
        >
         <span style="margin-left: 10px;"><a href="#"><i class="fa fa-home"></i> Promotions</a></span>
             <ul style="margin-left: 10px;">
                <li>
                  <router-link class="nav-link nav-link-collapse collapsed" to="#">
                    <i class="fa fa-home"></i><span class="nav-link-text">Customer Connect</span>
                  </router-link>
                </li>
                <li>
                  <router-link class="nav-link nav-link-collapse collapsed" to="/banner-list">
                    <i class="fa fa-home"></i><span class="nav-link-text">Banner Ads</span>
                  </router-link>
                </li>
                <li>
                  <router-link class="nav-link nav-link-collapse collapsed" to="/featured-list">
                    <i class="fa fa-home"></i><span class="nav-link-text">Featured List</span>
                  </router-link>
                </li>
            </ul>
        </li>
        

        <li
          class="nav-item"
          v-show="roleId == 3"
          data-toggle="tooltip"
          title=""
          data-original-title="My Account"
        >
          <router-link
            class="nav-link nav-link-collapse collapsed"
            to="/offers-of-interest"
          >
            <i class="fa fa-home"></i>
            <span class="nav-link-text">Offer of Interest</span>
          </router-link>
        </li>

        <li
          class="nav-item"
          v-show="roleId == 3"
          data-toggle="tooltip"
          title=""
          data-original-title="My Account"
        >
          <router-link
            class="nav-link nav-link-collapse collapsed"
            to="/my-journey"
            aria-expanded="false"
          >
            <i class="fa fa-home"></i>
            <span class="nav-link-text">Travel History</span>
          </router-link>
        </li>
        <!--li
          class="nav-item"
          v-show="roleId == 3"
          data-toggle="tooltip"
          title=""
          data-original-title="My Account"
        >
          <a
            class="nav-link nav-link-collapse collapsed"
            href="/new-journey"
            aria-expanded="false"
          >
            <i class="fa fa-home"></i>
            <span class="nav-link-text">New Journey</span>
          </a>
        </li-->
        <li
          class="nav-item"
          v-show="roleId == 2"
          data-toggle="tooltip"
          title=""
          data-original-title="My Account"
        >
          <router-link
            class="nav-link nav-link-collapse collapsed"
            to="/packages"
            aria-expanded="false"
          >
            <i class="fa fa-inr"></i>
            <span class="nav-link-text">Purchase New Packages</span>
          </router-link>
        </li>
        <li
          class="nav-item"
          data-toggle="tooltip"
          title=""
          data-original-title="My Account"
        >
          <router-link
            class="nav-link nav-link-collapse collapsed"
            to="/my-profile"
            aria-expanded="false"
          >
            <i class="fa fa-user"></i>
            <span class="nav-link-text">My Profile</span>
          </router-link>
        </li>
        <li
          class="nav-item"
          data-toggle="tooltip"
          title=""
          data-original-title="My Account"
        >
          <a href="javascript:void(0);" style="margin-left: 15px;"  @click="chatModal()"><i class="fa fa-commenting-o"></i> Chat</a>
        </li>
        <li
          class="nav-item"
          v-show="roleId == 3"
          data-toggle="tooltip"
          title=""
          data-original-title="Rewards"
        >
          <router-link
            class="nav-link nav-link-collapse collapsed"
            to="/rewards"
            aria-expanded="false"
          >
            <i class="fa fa-inr"></i>
            <span class="nav-link-text">Rewards</span>
          </router-link>
        </li>
       
        <li
          class="nav-item"
          v-show="roleId == 3"
          data-toggle="tooltip"
          title=""
          data-original-title="Get Quotation"
        >
          <router-link
            to="/requirement-list"
            class="nav-link nav-link-collapse collapsed"
            ><i class="fa fa-bullhorn"></i>
            <span class="nav-link-text">Requirements</span></router-link
          >
        </li>
        <li
          class="nav-item"
          data-toggle="tooltip"
          title=""
          data-original-title="Notification"
        >
          <router-link
            to="/notification"
            class="nav-link nav-link-collapse collapsed"
            ><i class="fa fa-bullhorn"></i>
            <span class="nav-link-text">Notification</span></router-link
          >
        </li>
        <li
          class="nav-item"
          data-toggle="tooltip"
          title=""
          data-original-title="Wishlist"
        >
          <router-link
            to="/wishlist"
            class="nav-link nav-link-collapse collapsed"
            ><i class="fa fa-bullhorn"></i>
            <span class="nav-link-text">Wishlist</span></router-link
          >
        </li>
      </ul>
    </div>
    <div class="box_detail" v-else>
      <ul class="cart_details">
        <li
          class="nav-item"
          data-toggle="tooltip"
          title=""
          data-original-title="My Account"
        >
          <router-link
            class="nav-link nav-link-collapse collapsed"
            to="/my-profile"
            aria-expanded="false"
          >
            <i class="fa fa-user"></i>
            <span class="nav-link-text">My Profile</span>
          </router-link>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
export default {
  data() {
    console.log("user status=" + localStorage.getItem("user_status"));
    return {
      roleId: localStorage.getItem("role_id"),
      userStatus: localStorage.getItem("user_status"),
    };
  },
  methods:{

    chatModal(){
      window.open(`https://peekzy.in/chat/?userid=${btoa(localStorage.getItem("user_id"))}&role=${btoa(localStorage.getItem("role_id"))}`, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=400,width=1000,height=800");
    }
  }
};
</script>


<style scoped>
a {
  color: #f54149;
}
.cart_details > li {
  border-bottom: 1px solid black;
}
.cart_details li span {
  float: none;
  padding-left: 4px;
}
</style>